import React from 'react'

export default function Login() {
  return (
    <div>
      <p>LOGIN</p>
    </div>
  )
}
